import { makeStyles } from "@fluentui/react-components";
import { Outlet } from "react-router";

const useStyles = makeStyles({
    root: {
        padding: "1rem"
    }
});

export default function Template() {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <Outlet />
        </div>
    );
}